export const isLocalHost = ['localhost', '127.0.0.1'].includes(
	window.location.hostname
);
